import createIcon from '../../createIcon';

/**
 * @component @name OutlinedFlag
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA1LjVMMTIuNSAzLjVINC41VjIwLjVINi41VjEzLjVIMTEuNUwxMi41IDE1LjVIMTkuNVY1LjVIMTMuNVpNMTcuNSAxMy41SDEzLjVMMTIuNSAxMS41SDYuNVY1LjVIMTEuNUwxMi41IDcuNUgxNy41VjEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OutlinedFlag = createIcon('OutlinedFlag', [
  [
    'path',
    {
      d: 'M13.5 5.5L12.5 3.5H4.5V20.5H6.5V13.5H11.5L12.5 15.5H19.5V5.5H13.5ZM17.5 13.5H13.5L12.5 11.5H6.5V5.5H11.5L12.5 7.5H17.5V13.5Z',
      key: '1qwm6q',
    },
  ],
]);

export default OutlinedFlag;
